// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  matchId: __t.string().name("match_id"),
  tick: __t.u32(),
  eventType: __t.string().name("event_type"),
  unitId: __t.option(__t.string()).name("unit_id"),
  targetId: __t.option(__t.string()).name("target_id"),
  unitAId: __t.option(__t.string()).name("unit_a_id"),
  unitBId: __t.option(__t.string()).name("unit_b_id"),
  unitName: __t.option(__t.string()).name("unit_name"),
  unitAName: __t.option(__t.string()).name("unit_a_name"),
  unitBName: __t.option(__t.string()).name("unit_b_name"),
  armyIndex: __t.option(__t.u32()).name("army_index"),
  structureIndex: __t.option(__t.u32()).name("structure_index"),
  team: __t.option(__t.u32()),
  previousTeam: __t.option(__t.u32()).name("previous_team"),
  orderType: __t.option(__t.string()).name("order_type"),
  friendlyFire: __t.option(__t.bool()).name("friendly_fire"),
  bonus: __t.option(__t.f64()),
});
